import { render, staticRenderFns } from "./myInheritorTeam.vue?vue&type=template&id=14ec1408&scoped=true&"
import script from "./myInheritorTeam.vue?vue&type=script&lang=js&"
export * from "./myInheritorTeam.vue?vue&type=script&lang=js&"
import style0 from "./myInheritorTeam.vue?vue&type=style&index=0&id=14ec1408&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14ec1408",
  null
  
)

export default component.exports